import {
  Box,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import PhoneScreen from "./PhoneScreen";
import { useQuestByHash, usePromotion, useQuestTarget } from "@quest_editor/mocks";
import { PreviewQuest, PhoneStatus } from "@quest_editor/mocks/data";

const QuestPreview = () => {
  const { t } = useTranslation("questEditor");
  const { hash } = useParams<{ hash: string }>();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { data: questData } = useQuestByHash(hash);
  const questFromApi = questData?.quest;
  const { data: promotionData } = usePromotion(questFromApi?.promotionId);
  const promotion = promotionData?.promotion;
  const { data: questTargetData } = useQuestTarget(questFromApi?.id);
  const questTarget = questTargetData?.questTarget;

  const phoneStatus: PhoneStatus = {
    time: dayjs().format("H:mm"),
    battery: String(Math.floor(Math.random() * 81) + 20),
  };

  if (!questFromApi) {
    return (
      <Box
        sx={{
          height: "100vh",
          bgcolor: "grey.100",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6" color="text.secondary">
          {t("preview.not_found")}
        </Typography>
      </Box>
    );
  }

  const targetProducts = questTarget?.products?.map((p) => ({
    name: p.name,
    barcode: p.barcode,
  }));

  const quest: PreviewQuest = {
    id: questFromApi.id,
    name: questFromApi.name,
    company: promotion?.name || "",
    description: questFromApi.description,
    incentiveType: questFromApi.incentiveType,
    tamaruPoint: questFromApi.tamaruPoint,
    prizeName: questFromApi.prizeName,
    imageUrl: questFromApi.imageUrl,
    startAt: questFromApi.startAt,
    endAt: questFromApi.endAt,
    targetProducts,
  };

  if (isMobile) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          bgcolor: "white",
          overflow: "hidden",
        }}
      >
        <PhoneScreen quest={quest} showStatusBar={false} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: "100vh",
        bgcolor: "grey.100",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
        {quest.name}
      </Typography>

      <Paper
        elevation={8}
        sx={{
          width: 390,
          height: "calc(100vh - 120px)",
          maxHeight: 844,
          borderRadius: 4,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          bgcolor: "white",
        }}
      >
        <PhoneScreen quest={quest} phoneStatus={phoneStatus} />
      </Paper>
    </Box>
  );
};

export default QuestPreview;
